/* 新規作成ボタン＆ブランド選択モーダル */
import React from 'react';
import ModalTemplate from '../molecules/ModalTemplate';
var NewRegistration = function (_a) {
    var toggleShowNewRegistrationModal = _a.toggleShowNewRegistrationModal, is_loading = _a.is_loading, show_new_registration_modal = _a.show_new_registration_modal, handleChangeNewRegistrationBrand = _a.handleChangeNewRegistrationBrand, option_of_brands = _a.option_of_brands, handleClickNewRegistration = _a.handleClickNewRegistration, t = _a.t;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "col-md-2" },
            React.createElement("button", { className: "btn btn-main-color form-btn-size", onClick: toggleShowNewRegistrationModal, disabled: is_loading }, t('新規作成'))),
        React.createElement(ModalTemplate, { show: show_new_registration_modal, title: t('新規作成'), body: React.createElement("div", { className: "new-registration-modal" },
                React.createElement("select", { id: "new_registration_modal_brand", onChange: handleChangeNewRegistrationBrand }, option_of_brands.map(function (option) {
                    return option.value !== '' && (React.createElement("option", { key: option.key, value: option.key }, option.value));
                }))), ClickCallBackNo: function () {
                toggleShowNewRegistrationModal();
            }, ClickCallBackYes: function () {
                toggleShowNewRegistrationModal();
                handleClickNewRegistration();
            }, t: t })));
};
export default NewRegistration;
